import React from "react";

const AcceptableUsePolicy = () => {
  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "50px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", textAlign: "left" }}>
      <h1>EdXcelerate Acceptable Use Policy</h1>
      <p><strong>Effective Date:</strong> January 1, 2025</p>
      <p><strong>Contact:</strong> Ryan Foulke – ryan@edxcelerate.com</p>

      <p>
        At EdXcelerate, our mission is to support students in planning and advancing their educational goals. As part of this 
        commitment, we expect all users of our platform to engage in responsible and lawful behavior that aligns with 
        educational integrity and student protections, including compliance with the <strong>Family Educational Rights and Privacy 
        Act (FERPA)</strong> and all <strong>applicable anti-discrimination laws</strong>.
      </p>

      <p>
        This Acceptable Use Policy ("Policy") sets forth rules that govern your use of the EdXcelerate platform, including 
        all features, content, tools, and services ("Service"). Any use of the Service in violation of this Policy may result 
        in suspension or termination of access at EdXcelerate's sole discretion, without prior notice.
      </p>

      <h2>1. Compliance with FERPA and Anti-Discrimination Laws</h2>
      <p>
        Users <strong>must comply fully with FERPA</strong> and all federal, state, and local laws regarding student data privacy and 
        educational records. Any misuse of educational data, including unauthorized access, disclosure, or retention of 
        student information, is strictly prohibited.
      </p>
      <p>
        EdXcelerate does <strong>not support</strong> and will not tolerate any use of the Service that discriminates against individuals 
        based on race, color, religion, sex (including pregnancy, sexual orientation, or gender identity), national origin, 
        age, disability, or genetic information, or any other status protected by applicable laws.
      </p>
      <p>You may not use the Service to:</p>
      <ul>
        <li>Engage in discriminatory practices or speech;</li>
        <li>Promote hostility or violence against any individual or group based on protected characteristics;</li>
        <li>Violate the rights or dignity of others in any form.</li>
      </ul>
      <p>Violation of these principles may result in immediate and permanent termination of your access to EdXcelerate.</p>

      <h2>2. Prohibited Conduct and Content</h2>
      <p>
        You agree not to upload, share, design, or otherwise use the EdXcelerate platform, directly or indirectly, to:
      </p>
      <ul>
        <li>Violate FERPA or other data privacy laws;</li>
        <li>Harass, abuse, defame, threaten, or stalk any individual;</li>
        <li>Create or distribute content that is racist, sexist, homophobic, or otherwise offensive;</li>
        <li>Encourage or facilitate illegal activity or promote the sale of unlawful goods or services;</li>
        <li>Distribute sexually explicit, pornographic, or otherwise obscene materials;</li>
        <li>Target, exploit, or endanger minors in any way;</li>
        <li>Promote self-harm, suicide, violence, or any form of physical or emotional harm;</li>
        <li>Infringe on intellectual property rights or share unauthorized content;</li>
        <li>Spread misinformation, disinformation, or fraudulent claims;</li>
        <li>Undermine democratic institutions or public trust in civic processes;</li>
        <li>Violate any applicable local, national, or international law.</li>
      </ul>

      <h2>3. Enforcement and Updates</h2>
      <p>
        EdXcelerate reserves the right to review and remove content or suspend access to any user that it determines, in its 
        sole discretion, to be in violation of this Policy. This Policy may be updated periodically, and continued use of 
        the platform after changes are made constitutes acceptance of the revised terms.
      </p>

      <p>For questions or concerns about this Policy, please contact:</p>
      <p>
        Ryan Foulke<br />
        Email: ryan@edxcelerate.com
      </p>
    </div>
  );
};

export default AcceptableUsePolicy;